import AddIcon from "@mui/icons-material/Add";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import ApprovalIcon from "@mui/icons-material/Approval";
import BarChartIcon from "@mui/icons-material/BarChart";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ReplayIcon from "@mui/icons-material/Replay";
import SyncIcon from "@mui/icons-material/Sync";
import UpgradeIcon from "@mui/icons-material/Upgrade";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Avatar, Box, Button, Chip, Divider, LinearProgress, Stack, Tooltip, Typography } from "@mui/material";
import { GridActionsCellItem, GridColDef, GridRowParams, GridRowsProp } from "@mui/x-data-grid";
import React, { useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import { ModalContext } from "../../../../../Components/Modals";
import ModalApplyJobOrWorkflow, {
  ModalApplyJobOrWorkflowElementProps,
} from "../../../../../Components/Modals/ModalApplyJobOrWorkflow/modal-apply-job-or-workflow";
import ModalChangeStatus, {
  ModalChangeStatusElementProps,
} from "../../../../../Components/Modals/ModalAssetActions/modal-change-status";
import ModalQualityCheck, {
  ModalQualityCheckElementProps,
} from "../../../../../Components/Modals/ModalAssetActions/modal-quality-check";
import ModalConfirmAction, {
  ModalConfirmActionElementProps,
} from "../../../../../Components/Modals/ModalConfirmAction/modal-confirm-action";
import ModalJobRetry, {
  ModalJobRetryElementProps,
} from "../../../../../Components/Modals/ModalJobRetry/modal-job-retry";
import ModalRequestPurge, {
  ModalRequestPurgeElementProps,
} from "../../../../../Components/Modals/ModalPurgeAsset/modal-request-purge";
import ModalSetFollowers, {
  ModalSetFollowersElementProps,
} from "../../../../../Components/Modals/ModalSetFollowers/modal-set-followers";
import ModalJobDetails, {
  ModalJobDetailsElementProps,
} from "../../../../../Components/Modals/ModalShowDetails/modal-job-details";
import ModalWorkflowDetails, {
  ModalWorkflowDetailsElementProps,
} from "../../../../../Components/Modals/ModalShowDetails/modal-workflow-details";
import DataTable, { CellSize } from "../../../../../Components/Table/table";
import TableCellDateTime from "../../../../../Components/Table/TableCellDateTime/table-cell-date-time";
import TableCellStringExpend from "../../../../../Components/Table/TableCellStringExpend/table-cell-string-expend";
import TableSkeleton from "../../../../../Components/Table/TableSkeleton";
import {
  assetService,
  eventsNotifier,
  jobBrokerService,
  jobsNotifier,
  orderService,
  workflowService,
} from "../../../../../Core/Api/services";
import { AclTypes } from "../../../../../Core/Api/Types/acl-types";
import { CreateInternalOrderRequest } from "../../../../../Core/Api/Types/create-internal-order-request";
import { DbAssetObjectInfos } from "../../../../../Core/Api/Types/db-asset-object-infos";
import { GetJobsResponse } from "../../../../../Core/Api/Types/get-jobs-response";
import { JobStatus } from "../../../../../Core/Api/Types/job-status";
import { ListWorkflowInstanceResponse } from "../../../../../Core/Api/Types/list-workflow-instance-response";
import { ObjectClass } from "../../../../../Core/Api/Types/object-class";
import { ObjectLayer } from "../../../../../Core/Api/Types/object-layer";
import { OrderProductType } from "../../../../../Core/Api/Types/order-product-type";
import { SwitchClassRequest } from "../../../../../Core/Api/Types/switch-class-request";
import { WorkflowStatus } from "../../../../../Core/Api/Types/workflow-status";
import GlobalConst from "../../../../../Core/Utils/Constants/globals";
import {
  AddOrUpdateJobOrWorkflow,
  DeleteJobOrWorklow,
  GetObjectActionsDto,
  GetObjectJobs,
  isJob,
  isWorkflow,
  SetFetchedJobsAndWorkflows,
} from "../../../../../Redux/Reducers/redux-slice-asset";
import { useAppDispatch, useAppSelector } from "../../../../../Redux/redux-store";
import { AclMatch, UserHasAcl, UserHasAcls } from "../../../../../Utils/helpers";
import useCustomSnackbar from "../../../../../Utils/Hooks/useCustomSnackbar";
import { routePaths } from "../../../../../Router/router";
import { useTranslation } from "react-i18next";
import { EventNotifierOperation } from "../../../../../Core/Api/notifier-client";
import { useGridApiRef } from "@mui/x-data-grid-premium";
import { GetPlayerInfos } from "../../../../../Redux/Reducers/redux-slice-layout";
import TableUuids from "../../../../../Components/Table/table-uuids";
import { DbJobInfos } from "../../../../../Core/Api/Types/db-job-infos";
import { DbWorkflowInstanceInfos } from "../../../../../Core/Api/Types/db-workflow-instance-infos";

function AssetSingleActions() {
  const { t } = useTranslation();
  const { id } = useParams();

  const customSnackbar = useCustomSnackbar();
  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const apiGrid = useGridApiRef();

  const [isLoading, setIsLoading] = React.useState(true);
  const [reload, setReload] = React.useState(0);
  const jobs = useAppSelector(GetObjectJobs);
  const asset = useAppSelector(GetObjectActionsDto);
  const isSuperUser = UserHasAcl(AclTypes.aclSuperUser);

  const { containerHeight } = useAppSelector(GetPlayerInfos);

  const handleSocketMessage = useCallback(
    (data) => {
      if ((!data.data?.objectId || data.data.objectId !== asset?.id) && !jobs?.find((x) => x.id === data.data?.id))
        return;
      switch (data.op) {
        case (EventNotifierOperation.Create, EventNotifierOperation.Update):
          dispatch(AddOrUpdateJobOrWorkflow(data.data));
          apiGrid.current?.updateRows([{ ...data.data }]);
          break;

        case EventNotifierOperation.Delete:
          dispatch(DeleteJobOrWorklow(data.data.id));
          apiGrid.current?.updateRows([{ _action: "delete", ...data.data }]);
          break;
      }
    },
    [asset?.id, jobs, jobs?.length]
  );
  // SignalR
  React.useEffect(() => {
    if (asset?.id) {
      eventsNotifier.Connect().then(function (result) {
        console.debug("Hub Events Connected successfully to WebSocket and is listening to WorkflowInstanceMessage");
        if (eventsNotifier.connection) eventsNotifier.connection.on("WorkflowInstanceMessage", handleSocketMessage);
      });

      jobsNotifier.Connect().then(function (result) {
        console.debug("Hub Jobs Connected successfully to WebSocket and is listening to JobInfoMessage!");
        if (jobsNotifier.connection) jobsNotifier.connection.on("JobInfoMessage", handleSocketMessage);
      });
    }

    // Disconnect when unmount
    return function cleanup() {
      eventsNotifier.Disconnect().then(function () {});
      jobsNotifier.Disconnect().then(function () {});
    };
  }, [handleSocketMessage, asset?.id]);

  React.useEffect(() => {
    if (!id) return;
    const _id = Number(id);

    setIsLoading(true);

    const jobPromise = UserHasAcl(AclTypes.aclSuperUser)
      ? jobBrokerService.ListByObjectId(_id)
      : new Promise<GetJobsResponse>((resolve) => {
          resolve(new GetJobsResponse({}));
        });

    const workflowPromise = UserHasAcls(
      [AclTypes.aclBackofficeWorkflowAdmin, AclTypes.aclWorkflowView],
      AclMatch.OneAtLeast
    )
      ? workflowService.GetInstancesByAssetId(_id)
      : new Promise<ListWorkflowInstanceResponse>((resolve) => {
          resolve(new ListWorkflowInstanceResponse({}));
        });

    Promise.all([jobPromise, workflowPromise]).then(([jobResponse, workflowResponse]) => {
      const jobs = jobResponse.jobs || [];
      const workflows = workflowResponse.instances || [];
      dispatch(SetFetchedJobsAndWorkflows({ jobs, workflows }));
      setIsLoading(false);
    });
  }, [id, reload]);

  // handling switch asset
  const handleSwitchClass = () => {
    if (!openModal) return;

    openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
      displayComment: true,
      commentLabel: t("modal:comment.letUsKnowSwitchClassReason"),
      title: t("modal:title.switchAssetToClass", {
        context: asset?.classification === ObjectClass.Mezz ? "raw" : "mezz",
      }),
      onConfirm: HandleAssetSwitchClass,
    });
  };
  const HandleAssetSwitchClass = (comment?: string) => {
    let request = new SwitchClassRequest({
      assetId: asset?.id,
      classification: asset?.classification === ObjectClass.Mezz ? ObjectClass.Raw : ObjectClass.Mezz,
      annotation: comment,
    });
    assetService.SwitchObjectClass(request).then((response) => {
      if (response.success) {
        if (response.objectId === GlobalConst.ELEVATION_RESPONSE_OBJECT_ID)
          customSnackbar(response.message!, "primary");
        else customSnackbar(t("alert:success.switchingAssetClassDone"), "success");
      } else customSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
    });
  };

  // handling set followers
  const handleSetFollowers = () => {
    if (!openModal) return;
    openModal<ModalSetFollowersElementProps>(ModalSetFollowers, {
      objectIds: [asset!.id],
      objectType: "asset",
      currentFollowersIds: asset!.currentFollowersIds,
    });
  };

  // handling change asset status
  const handleAssetChangeStatus = () => {
    if (!openModal) return;
    const data = {
      id: asset!.id,
      classification: asset!.classification,
      status: asset!.status,
      type: asset!.type,
    };
    openModal<ModalChangeStatusElementProps>(ModalChangeStatus, {
      asset: data as DbAssetObjectInfos,
    });
  };

  // handling requalify asset
  const handleAssetRequalify = () => {
    if (!openModal) return;
    openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
      displayComment: false,
      commentLabel: t("modal:title.confirmAssetRequalify"),
      title: t("modal:title.confirmAssetRequalify"),
      onConfirm: HandleRequalify,
    });
  };
  const HandleRequalify = () => {
    let request = new CreateInternalOrderRequest({
      assetId: asset?.id,
      comment: "Qualify Request",
      productType: OrderProductType.Qualify,
      parameters: null,
    });
    orderService.CreateInternalOrder(request).then(() => {
      customSnackbar(t("alert:success.assetQualifyRequestDone"), "success");
    });
  };

  // handling QC asset
  const handleQCOrder = () => {
    if (!openModal) return;
    const data = {
      id: asset!.id,
      name: asset!.name,
      classification: asset!.classification,
      status: asset!.status,
      type: asset!.type,
    };
    openModal<ModalQualityCheckElementProps>(ModalQualityCheck, {
      assets: [data as DbAssetObjectInfos],
    });
  };

  // handling apply job
  const handleApplyJob = () => {
    if (!openModal) return;
    openModal<ModalApplyJobOrWorkflowElementProps>(ModalApplyJobOrWorkflow, {
      isJob: true,
      assetIds: [asset!.id],
      onSuccess: () => setReload((prev) => prev + 1),
    });
  };

  // handling apply workflow
  const handleApplyWorkflow = () => {
    if (!openModal) return;
    openModal<ModalApplyJobOrWorkflowElementProps>(ModalApplyJobOrWorkflow, {
      isJob: false,
      assetIds: [asset!.id],
      onSuccess: () => setReload((prev) => prev + 1),
    });
  };

  // handling purge MF
  const handlePurgeRequest = () => {
    // validation message length must be > 10
    if (!openModal || asset?.id === undefined) return;
    openModal<ModalRequestPurgeElementProps>(ModalRequestPurge, {
      title: t("modal:title.requestMediaFilesPurge"),
      assetIds: [asset?.id],
    });
  };

  // handling delete obj
  const handleDeleteRequest = () => {
    if (!openModal || asset?.id === undefined) return;
    openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
      displayComment: false,
      title: t("modal:title.deleteAssetDefinitely"),
      onConfirm: (comment) => {
        assetService.DeleteObjectById(asset?.id).then((response) => {
          if (response.success) {
            customSnackbar(t("alert:success.assetHasBeenDeleted"), "success");
            navigate(routePaths.home.path);
          } else customSnackbar(t("alert:warning.oopsErrorDeletingAsset", { message: response.message }), "warning");
        });
      },
    });
  };

  // handling show details (job & workflow)
  const handleShowDetails = (item: DbJobInfos | DbWorkflowInstanceInfos) => {
    if (!openModal) return;
    if (isJob(item)) {
      openModal<ModalJobDetailsElementProps>(ModalJobDetails, {
        job: item,
        onRetryCallback: handleRetry,
        onResyncCallback: handleResync,
        onAbortCallback: handleAbort,
      });
    } else if (isWorkflow(item)) {
      openModal<ModalWorkflowDetailsElementProps>(ModalWorkflowDetails, {
        workflow: item,
        onRetryCallback: handleRetry,
        onDeleteCallback: handleDelete,
        onAbortCallback: handleAbort,
      });
    } else {
    }
  };

  // handling retry (job & workflow)
  const handleRetry = (item: DbJobInfos | DbWorkflowInstanceInfos) => {
    if (isJob(item)) {
      //opening modal
      if (!openModal) return;
      openModal<ModalJobRetryElementProps>(ModalJobRetry, {
        message: t("modal:message.modalJobRetryMessage"),
        title: t("modal:title.retryNow"),
        jobId: item.id,
      });
    } else {
      if (!openModal) return;
      openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
        displayComment: false,
        title: t("modal:title.retryNowLowerCase"),
        commentLabel: t("modal:comment.confirmRetryWorkflowInstance"),
        onConfirm: () => handleRetryWorkflowConfirm(item),
      });
    }
  };

  const handleRetryWorkflowConfirm = (item: any) => {
    workflowService.RetryInstance(item.id).then((response) => {
      if (response.success) customSnackbar(t("alert:success.workflowRetried"), "success");
      else customSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
    });
  };

  // handling abort (job & workflow)
  const handleAbort = (item: DbJobInfos | DbWorkflowInstanceInfos) => {
    if (isJob(item)) {
      jobBrokerService.Abort(item.id).then(() => {
        customSnackbar(t("alert:success.jobAborted"), "success");
      });
    } else {
      if (!openModal) return;
      openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
        displayComment: false,
        commentLabel: t("modal:comment.confirmAbortWorkflowInstance"),
        title: t("modal:title.abortNow"),
        onConfirm: () => handleAbortyWorkflowConfirm(item),
      });
    }
  };
  const handleAbortyWorkflowConfirm = (item: any) => {
    workflowService.AbortInstance(item.id).then((response) => {
      if (response.success) customSnackbar(t("alert:success.workflowAborted"), "success");
      else customSnackbar(t("alert:error.oopsWithMessage", { message: response.message }), "warning");
    });
  };

  // handling abort workflow
  const handleDelete = (item: any) => {
    if (!openModal) return;
    openModal<ModalConfirmActionElementProps>(ModalConfirmAction, {
      commentLabel: t("modal:comment.confirmDeleteWorkflowInstance"),
      title: t("modal:title.deleteInstance"),
      onConfirm: () => handleDeleteWorkflowConfirm(item),
    });
  };

  const handleDeleteWorkflowConfirm = (item: DbWorkflowInstanceInfos) => {
    workflowService.DeleteInstance(item.id).then(() => {
      customSnackbar(t("alert:success.workflowHasBeenDeleted"), "success");
    });
  };

  // handling resync job
  const handleResync = (item: DbJobInfos) => {
    jobBrokerService.NotifyResync(item.id).then(() => {
      customSnackbar(t("alert:success.jobResync"), "success");
    });
  };

  // Table creation

  const columns: GridColDef<DbJobInfos | DbWorkflowInstanceInfos>[] = [
    {
      field: "id",
      headerName: "Id",
      minWidth: CellSize.xsmall,
      flex: CellSize.xsmall,
      renderCell: (data) => (
        <Typography variant="body2" fontWeight={500}>
          #{data.value}
        </Typography>
      ),
    },
    {
      field: "is",
      headerName: t("common:kind"),
      minWidth: CellSize.xsmall,
      flex: CellSize.xsmall,
      valueGetter: (_, row) => {
        if (!row) return;
        if (isJob(row)) return "Job";
        if (isWorkflow(row)) return "Workflow";
        return "";
      },
      renderCell: (data) => <Chip label={data.value} />,
    },
    {
      field: "type",
      headerName: t("common:type"),
      minWidth: CellSize.large,
      flex: CellSize.large,
      valueGetter: (_, row) => {
        if (!row) return;
        if (isJob(row)) return row.type;
        if (isWorkflow(row)) return row.definitionType;
        return "";
      },
      renderCell: (data) => <Chip title={data.value} label={data.value ?? "-"} />,
    },
    {
      field: "createdByUserName",
      headerName: t("common:createdByUpperCase"),
      minWidth: CellSize.small,
      flex: CellSize.small,
      valueGetter: (_, row) => {
        if (!row) return;
        if (isJob(row)) return row.owner ? row.owner.firstName + " " + row.owner.lastName : "";
        if (isWorkflow(row)) return row.createdByUserName;
        return "";
      },
      renderCell: (data) =>
        data.value && data.value !== "" ? (
          <Tooltip title={data.value}>
            <Avatar
              sx={{
                width: 33,
                height: 33,
                backgroundColor: "backgroundAlpha.main",
                color: "common.white",
                fontSize: 12,
              }}
            >
              {data.value.split(" ").shift().charAt(0) + data.value.split(" ").pop().charAt(0)}
            </Avatar>
          </Tooltip>
        ) : (
          <>-</>
        ),
    },
    {
      field: "createdAt",
      headerName: t("common:startDateLowerCase"),
      minWidth: CellSize.small,
      flex: CellSize.small,
      valueGetter: (_, row) => {
        if (!row) return;
        if (isJob(row)) return row.createdAt;
        if (isWorkflow(row)) return row.creationInfos.date;
        return "";
      },
      renderCell: (data) => <TableCellDateTime data={data} />,
    },
    {
      field: "endedAt",
      headerName: t("common:endDateLowerCase"),
      minWidth: CellSize.small,
      flex: CellSize.small,
      valueGetter: (_, row) => {
        if (!row) return;
        if (isJob(row)) return row.endedAt;
        if (isWorkflow(row)) return row.endTime;
        return "";
      },
      renderCell: (data) => <TableCellDateTime data={data} />,
    },
    {
      field: "status",
      headerName: t("common:status"),
      minWidth: CellSize.large,
      flex: CellSize.large,
      renderCell: (data) => <> {renderStatus(data)}</>,
    },
    {
      field: "currentTaskName",
      headerName: t("table:headerName.currentTask"),
      minWidth: CellSize.large,
      flex: CellSize.large,
      valueGetter: (_, row) => {
        if (!row) return;
        if (isJob(row)) return row.summarize;
        if (isWorkflow(row)) return row.currentTaskName;
        return "";
      },
      renderCell: (data) => <TableCellStringExpend data={data} />,
    },
    {
      field: "actions",
      headerName: "",
      type: "actions",
      align: "right",
      minWidth: CellSize.actionsLarge,
      flex: CellSize.actionsLarge,
      getActions: (data) => {
        if (!data || !data.row) return [];
        return renderActions(data);
      },
    },
  ];

  // status rendering
  const renderStatus = (data) => {
    switch (data.value) {
      case WorkflowStatus.READY:
      case WorkflowStatus.CREATED:
        return (
          <>
            <Typography display="inline-flex" color="default.main" variant="body2">
              <AlarmOnIcon fontSize="small" sx={{ mr: 0.5 }} />
              {data.value}
            </Typography>
          </>
        );
      case WorkflowStatus.COMPLETED:
        return (
          <>
            <Typography display="inline-flex" color="success.main" variant="body2">
              <DoneIcon fontSize="small" sx={{ mr: 0.5 }} />
              {data.value}
            </Typography>
            <LinearProgress
              color="success"
              variant="determinate"
              value={data?.row?.progress}
              sx={{ width: 70, marginLeft: "10px" }}
            />
          </>
        );
      case WorkflowStatus.FAILED:
      case WorkflowStatus.CANCELLED:
      case WorkflowStatus.ABORTED:
        return (
          <>
            <Typography display="inline-flex" color="error.main" variant="body2">
              <ClearIcon fontSize="small" sx={{ mr: 0.5 }} />
              {data.value}
            </Typography>
            <LinearProgress
              color="error"
              variant="determinate"
              value={data?.row?.progress}
              sx={{ width: 70, marginLeft: "10px" }}
            />
          </>
        );
      case WorkflowStatus.RUNNING:
        return (
          <>
            <Typography display="inline-flex" color="primary.main" variant="body2">
              <SyncIcon fontSize="small" sx={{ mr: 0.5 }} />
              {data.value}
            </Typography>
            <LinearProgress variant="determinate" value={data?.row?.progress} sx={{ width: 70, marginLeft: "10px" }} />
          </>
        );
    }
  };

  // actions rendering
  const renderActions = (params: GridRowParams<DbJobInfos | DbWorkflowInstanceInfos>) => {
    const item = params.row;
    const show = (
      <GridActionsCellItem
        icon={<VisibilityIcon sx={{ width: 20, height: 20 }} />}
        label={t("common:show")}
        title={t("table:cellTitle.showItemDetails", { item: item.id })}
        onClick={() => handleShowDetails(item)}
      />
    );
    const retry = (
      <GridActionsCellItem
        icon={<ReplayIcon sx={{ width: 20, height: 20 }} />}
        label={t("common:retry")}
        title={t("table:cellTitle.retryItem", { item: item.id })}
        disabled={
          isJob(item)
            ? item.status !== JobStatus.ABORTED && item.status !== JobStatus.FAILED
            : (!isSuperUser && !UserHasAcl(AclTypes.aclBackofficeWorkflowAdmin)) || item.status !== WorkflowStatus.FAILED
        }
        onClick={() => handleRetry(item)}
      />
    );
    const resync = (
      <GridActionsCellItem
        icon={<SyncIcon sx={{ width: 20, height: 20 }} />}
        label={t("common:resync")}
        title={t("table:cellTitle.resyncItem", { item: item.id })}
        disabled={!isSuperUser || !isJob(item)}
        onClick={() => isJob(item) && handleResync(item)}
      />
    );
    const abort = (
      <GridActionsCellItem
        icon={<ClearIcon sx={{ width: 20, height: 20 }} />}
        label={t("common:abort")}
        title={t("table:cellTitle.abortItem", { item: item.id })}
        disabled={isJob(item) ? item.status !== JobStatus.RUNNING : !isSuperUser || item.status !== WorkflowStatus.RUNNING}
        onClick={() => handleAbort(item)}
      />
    );
    const remove = (
      <GridActionsCellItem
        icon={<DeleteIcon sx={{ width: 20, height: 20 }} />}
        label={t("common:delete")}
        title={t("table:cellTitle.deleteItem", { item: item.id })}
        disabled={
          !isSuperUser ||
          (item.status !== JobStatus.FAILED &&
            item.status !== JobStatus.ABORTED &&
            item.status !== JobStatus.READY &&
            item.status !== JobStatus.CANCELLED)
        }
        onClick={() => handleDelete(item)}
      />
    );
    if (isJob(item)) return [show, retry, resync, abort];
    else if (isWorkflow(item)) return [show, retry, remove, abort];
    else return [];
  };

  return (
    <>
      <Stack gap={2} pt={2}>
        <Typography component="h3" variant="h5">
          {t("common:actions")}
        </Typography>{" "}
        <Stack
          direction="row"
          alignItems="stretch"
          flexWrap={"wrap"}
          gap={1.5}
          sx={(theme) => ({ p: 2, background: theme.palette.background.paper, borderRadius: 1 })}
        >
          {asset?.userHasRightToSwitchClass && (
            <Button startIcon={<EditIcon />} onClick={handleSwitchClass}>
              {t("table:cellTitle.switchClass")}
            </Button>
          )}
          <Button startIcon={<GroupsOutlinedIcon />} onClick={handleSetFollowers}>
            {t("common:setFollowers")}
          </Button>
          <Button
            disabled={!asset?.userHasRightToChangeStatus}
            startIcon={<BarChartIcon />}
            onClick={handleAssetChangeStatus}
          >
            {t("common:changeStatus")}
          </Button>
          <Button
            startIcon={<UpgradeIcon />}
            onClick={handleAssetRequalify}
            disabled={!asset?.userHasRightToRequalifyAsset}
          >
            {t("button:requalifyAsset")}
          </Button>
          <Button disabled={!asset?.userHasRightToOrderQCCheck} startIcon={<CheckIcon />} onClick={handleQCOrder}>
            {t("menu:item.orderQualityCheck")}
          </Button>

          <Button disabled={!asset?.userHasRightToStartJob} startIcon={<AddIcon />} onClick={handleApplyJob}>
            {t("button:startJob")}
          </Button>

          <Button
            disabled={!asset?.userHasRightToStartWorkflow}
            startIcon={<ApprovalIcon />}
            onClick={handleApplyWorkflow}
          >
            {t("button:startWorkflow")}
          </Button>

          <Button
            color="error"
            startIcon={<HighlightOffIcon />}
            onClick={handlePurgeRequest}
            disabled={asset?.layer !== ObjectLayer.Asset || !asset.userHasRightToPurgeMediaFiles}
          >
            {t("common:requestPurge")}
          </Button>

          {asset?.userHasRightToDelete && (
            <Button color="error" startIcon={<DeleteForeverIcon />} onClick={handleDeleteRequest}>
              {t("button:deleteAssetDefinitely")}
            </Button>
          )}
        </Stack>
      </Stack>
      <Stack gap={2} pt={2} flex={"1 1 0%"} minHeight={"calc(100vh - 129px)"}>
        <Typography component="h3" variant="h5">
          {t("common:jobs")}
        </Typography>
        {isLoading || !jobs ? (
          <TableSkeleton />
        ) : (
          <DataTable
            tableKey={TableUuids.ASSET_SINGLE_ACTIONS}
            apiRef={apiGrid}
            rows={jobs}
            columns={columns}
            disableRowSelectionOnClick
            initialState={{
              pinnedColumns: { left: ["id", "kind"], right: ["actions"] },
            }}
            sortModel={[{ field: "createdAt", sort: "desc" }]}
            onRowClick={(item) => handleShowDetails(item.row)}
          />
        )}
      </Stack>
    </>
  );
}
export default AssetSingleActions;
